import APIV5 from '~/models/api';

export default class WfStateTodoController {
	#$location;

	#$timeout;

	#$translate;

	/* @ngInject */
	/**
	 * @param {import('angular').ILocationService} $location
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {import('angular').IScope} $scope
	 * @param {import('angular').IQService} $q
	 */
	constructor(
		$location,
		$timeout,
		$translate,
		$scope,
		$q,
	) {
		this.#$location = $location;
		this.#$timeout = $timeout;
		this.#$translate = $translate;
		this.$scope = $scope;
		this.$q = $q;

		/** @type {?string} */
		this.columnWfAffect = null;

		/** @type {any} */
		this.data = undefined;

		/** @type {boolean} */
		this.loading = false;

		/** @type {number} */
		this.nb = 0;

		/** @type {Function | undefined} */
		this.onDataLoaded = undefined;

		/** @type {any} */
		this.options = {
			movableColumns: true,
			layout:         'fitData',
			placeholder:    this.#$translate.instant('home.wf-title-no-actions'),
			maxHeight:         '100%',
			minHeight:         200,
			selectable:     'highlight',
			rowClick:       (/** @type {Event} */ event, /** @type {import('tabulator-tables').RowComponent} */ row) => {
				if (this.columnWfAffect) {
					this.openWorkflow(row.getData()[this.columnWfAffect].kid);
				}
			},
		};

		this.$scope.$on('wf-list:refresh', () => this.loadJobList());
	}

	datatableLoaded() {
		if (typeof this.onDataLoaded === 'function') {
			this.onDataLoaded();
		}
	}

	async loadJobList() {
		this.loading = true;

		/** @type {import('tabulator-tables').ColumnDefinition[]} */
		const columns = [];

		/** @type {any[]} */
		const rows = [];

		try {
			const data = await APIV5.instance.wfAffectTodo({}, {
				id: 'workflow-state-todo-controller',
			});

			for (const [col, header] of Object.entries(data.header)) {
				/** @type {import('tabulator-tables').ColumnDefinition} */
				const column = {
					title:     header.name,
					field:     col,
					formatter: cell => {
						const value = cell.getValue().type_kid === 'K_NODE;DATE'
							? new Date(cell.getValue().name).toLocaleString('short')
							: cell.getValue().name;

						const div = document.createElement('div');
						div.textContent = value;
						return div;
					},
					sorter: (a, b) => a.name.localeCompare(b.name),
					visible: header.hidden !== true,
				};
				columns.push(column);
				if (header.id === 'kid') {
					this.columnWfAffect = col;
				}
			}

			for (const row of data.rows) {
				/** @type {any} */
				const myRow = {};
				for (const [col, cell] of Object.entries(row)) {
					myRow[col] = cell;
				}
				rows.push(myRow);
			}
			this.$scope.$evalAsync(() => {
				this.nb = rows.length;
				this.data.setColumns(columns);
				this.data.replaceData(rows);
			});
		}
		catch (error) {
			console.error('Unable to fetch workflow', error);
		}
		finally {
			this.loading = false;
		}
	}

	/**
	 * @param {import('@knitiv/api-client-javascript').KNode} node
	 * @returns {import('angular').IPromise<any>}
	 */
	openWorkflow(node) {
		return this.#$timeout(() => this.#$location.url(`/workflow/${node}`));
	}

	$onInit() {
		(async () => this.loadJobList())();
	}
}
